import { FormattedMessage } from 'react-intl'
import { Text } from '../../..'
import {
  ListingSourceInfo,
  useComplianceData,
} from '../../../../services/mlsComplianceDataService'

interface ListingProvidedByMlsNameProps {
  listing: ListingSourceInfo
}

export const ListingProvidedByMlsName = ({
  listing,
}: ListingProvidedByMlsNameProps) => {
  const complianceData = useComplianceData(listing)

  if (!complianceData?.mlsName) {
    return null
  }

  return (
    <Text
      data-qa='listingProvidedByText'
      element='span'
      size='xxs'
      variant='neutralCool'
      variantCount='500'
    >
      <FormattedMessage
        id='HomeSearch.listingDetails.nmls.providedBy'
        defaultMessage='Listing provided/courtesy of {source}'
        values={{
          source: complianceData?.mlsName,
        }}
      />
    </Text>
  )
}
